export const categoryState = {
  categories: [],
  newlyUpdatedCategories: [],
};
